export default __webpack_public_path__ + "alberta-arrow-dropup.b0c30a2430087fd4b03e.svg";